export default __webpack_public_path__ + "static/media/li.a9bfde17.svg";